export const styles: { [key: string]: React.CSSProperties } = {
  gazableGameControls: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "50px",
    right: "0px",
    padding: "0 40px 0 40px",
    flexDirection: "column",
    background: "rgba(0, 0, 0, 0.5)",
  },
};
